import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgAttach = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.294 18.112C12.046 19.353 10.621 20 9.167 20c-1.474 0-2.925-.664-4.206-1.937-1.19-1.183-1.867-2.533-1.952-3.905-.095-1.535.565-3.05 1.903-4.38l5.543-5.51a.766.766 0 011.08 0 .756.756 0 010 1.075l-5.543 5.512c-1.039 1.03-1.526 2.11-1.458 3.21.062.991.582 2.002 1.508 2.922 1.853 1.844 3.97 2.238 6.171.05l6.106-6.074c1.46-1.452 1.534-3.233.197-4.563-1.313-1.302-2.956-1.16-4.456.332l-5.527 5.463c-.93.924-1.053 1.83-.3 2.578.695.691 1.593.612 2.553-.344l4.643-4.616a.767.767 0 011.08 0c.3.296.3.779 0 1.076l-4.643 4.616c-1.512 1.506-3.364 1.685-4.714.344-1.368-1.36-1.218-3.221.301-4.733l5.528-5.463c2.075-2.06 4.71-2.223 6.614-.33.906.901 1.406 2.044 1.405 3.215-.001 1.251-.556 2.462-1.6 3.501l-6.106 6.073z"
      clipRule="evenodd"
    />
  </svg>
));
SvgAttach.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgAttach;
